<page-with-permissions-wrapper>
  <velocity-report [board$]="board$" *ngIf="(isAllVersionsLoaded$ | async); else loader"></velocity-report>
</page-with-permissions-wrapper>
<ng-template #loader><a-loader></a-loader></ng-template>
